import * as yup from "yup";

import {
  alphanumericMessage,
  maxLengthMessage,
  minLengthMessage,
  requiredMessage,
} from "../validationMessages";

import { trimmedString } from "./trimmedString";

const MIN_LENGTH = 4;
const MAX_LENGTH = 10;

export const registrationNumberValidator = trimmedString
  .min(MIN_LENGTH, minLengthMessage(MIN_LENGTH))
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .matches(/^[a-z0-9]{4,10}$/i, {
    message: alphanumericMessage,
    excludeEmptyString: true,
  });
export const registrationNumberValidatorRequired = trimmedString
  .min(MIN_LENGTH, minLengthMessage(MIN_LENGTH))
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .matches(/^[a-z0-9]{4,10}$/i, alphanumericMessage)
  .required(requiredMessage);
export const registrationNumberValidatorOrRelation = yup
  .string()
  .test(function (value) {
    const { ocNumber } = this.parent;

    if (!ocNumber || ocNumber === "_______") {
      try {
        registrationNumberValidatorRequired.validateSync(value);
        return true;
      } catch (error) {
        return this.createError({ message: error.message, path: this.path });
      }
    }
    return true;
  });
